import React, { useState } from 'react';
import { Select, IconButton, Button } from 'htlib-copy';
import { func, string } from 'prop-types';

import { entitiesToSelectItems } from 'utils/select';
import customTypes from 'types';
import { useGetSingleCheck } from 'hooks/checks';
import AsyncUI from 'components/AsyncUI';

import { useUrlParam } from '../utils';
import ActionButtons from './ActionButtons';
import { formatPayloadForMission, indexEntities } from './utils';

export default function ActionClassifier({ checkId, entities, indexName, patchChecks }) {
  const { getUrlParam } = useUrlParam();
  const entityId = getUrlParam('entity');
  const tagValue = getUrlParam('tags');

  const [selectedEntityId, setSelectedEntityId] = useState(entityId);
  const formatPayloadClassifier = formatPayloadForMission(entities, 'classifier', indexName);

  const [showSelect, setShowSelect] = useState(false);
  const singleCheckQuery = useGetSingleCheck(
    checkId,
    { projection: 'labeling,check' },
    {
      enabled: showSelect,
      onSuccess({ check: { labeling, check = {} } }) {
        const [[yesEntity] = []] = Object.entries({ ...labeling, ...check }).filter(
          ([, value]) => value === 'yes',
        );
        setSelectedEntityId(yesEntity);
      },
    },
  );

  function sendCheck(value) {
    if (value === 'no') {
      setShowSelect(true);
    } else {
      patchChecks(formatPayloadClassifier(selectedEntityId, value));
    }
  }

  return (
    <div className="Action">
      {tagValue !== 'no_for_all' && <ActionButtons sendCheck={sendCheck} />}

      {showSelect ? (
        <div className="Action__select">
          <AsyncUI query={singleCheckQuery}>
            <Select
              withSearch
              placeholder="- Entity -"
              items={entitiesToSelectItems(indexEntities(entities, indexName))}
              onSelect={setSelectedEntityId}
              selectedValue={selectedEntityId}
            />
          </AsyncUI>
          <div className="Action__confirm">
            <IconButton
              icon="cancel"
              onClick={() => {
                setSelectedEntityId(entityId);
                setShowSelect(false);
              }}
            />

            {tagValue !== 'no_for_all' && (
              <Button
                type="warn"
                onClick={() => {
                  patchChecks({ noForAll: true });
                  setSelectedEntityId(entityId);
                  setShowSelect(false);
                }}
              >
                No for all
              </Button>
            )}

            <IconButton
              icon="confirm"
              onClick={() => {
                patchChecks(formatPayloadClassifier(selectedEntityId, 'yes'));
                setSelectedEntityId(entityId);
                setShowSelect(false);
              }}
            />
          </div>
        </div>
      ) : (
        <div className="Action__option">
          <Button
            type="primary"
            ghost
            onClick={() => {
              setShowSelect(true);
            }}
          >
            Change tag
          </Button>
        </div>
      )}
    </div>
  );
}

ActionClassifier.propTypes = {
  entities: customTypes.misc.missionEntities,
  patchChecks: func.isRequired,
  indexName: string.isRequired,
  checkId: string.isRequired,
};

ActionClassifier.defaultProps = { entities: {} };
